// removed by extract-text-webpack-plugin
module.exports = {"tooltipContainer":"_2qjP2CIuCvF2frWlFWUelo","tooltip":"Jgo8S1-kxU_-iulS3SPiw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TopTooltip/TopTooltip.scss
// module id = 1801
// module chunks = 0